import instance from "./axios";
import { PottingPostPayload, PottingType } from "../types/PottingTypes";

export const fetchLastPotting = async (): Promise<PottingType[]> => {
  const response = await instance.get<PottingType[]>(
    "/v1.0/Material/GetLastPotting?num=15"
  );
  return Array.isArray(response.data) ? response.data : [response.data];
};

export const postPotting = async (payload: PottingPostPayload) => {
  const res = await instance.post("/v1.0/Material/AddPotting", payload);
  return res.data;
};
